<template>
  <div id="metricsBilledReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Metrics Billed (Detail)</div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'metricsBilledReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="'metricsBilledReport'" :position="'top'">
                  </custom-pagination>
                  <vue-good-table
                    mode="remote"
                    title="Metrics Billed Report"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :columns="userColumns"
                    :rows="rows"
                    :paginationOptions="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        dropdownAllowAll: false,
                        setCurrentPage:listCurrentPage,
                        perPageDropdown:dropDownPerPage,
                    }"
                    :search-options="{
                    enabled: false,
                    }"

                    >
                  </vue-good-table>
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
                </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "MetricsBilledReport",
  metaInfo() {
            return {title: "Metrics Billed (Detail) Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: 'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
        {
          label: 'Agreement Header Type',
          field: 'agreement_header',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['RC','LC'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
        },
        {
          label: 'Agreement Number',
          field: 'agreement_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
        },
        {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
        },
        {
          label: 'Assign Date',
          field: 'assign_date',
          filterable: true,
          fpFieldType:"custom_date",
          hidden:false,
        },
        {
          label: 'Contract Base Amount',
          field: 'contract_base_amount',
          filterable: true,
          fpFieldType:"integer",
          hidden:false,
          type:'number',
        },
        {
          label: 'Contract Billed Amount',
          field: 'contract_billed_amount',
          filterable: true,
          fpFieldType:"integer",
          hidden:false,
          type:'number',
        },
        {
          label: 'Contract Billed Rate',
          field: 'contract_billed_rate',
          filterable: true,
          fpFieldType:"integer",
          type:'number',
          hidden:false,
        },
        {
          label: 'Contract Billed Tax',
          field: 'contract_billed_tax',
          filterable: true,
          fpFieldType:"integer",
          type:'number',
          hidden:false,
        },
        {
          label: 'Contract Billing Date',
          field: 'contract_bill_dt',
          filterable: true,
          fpFieldType:"custom_date",
          hidden:false,
        },
        {
          label: 'Billed',
          field: 'billed',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          width:'90px',
          sortable: false,
        },
        {
          label: 'Contract Type',
          field: 'conType',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
          width:'90px',
        },
        {
          label: 'Section',
          field: 'section',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
        },
        {
          label: 'Invoice Number',
          field: 'invoice_number',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
        },
        {
          label: 'Invoice Date',
          field: 'invoice_date',
          filterable: true,
          fpFieldType:"custom_date",
          hidden:false,
        },
        {
          label: 'Metric Type',
          field: 'metric_type',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
          width:'90px',
          sortable: true,
        },
        {
          label: 'Customer Number',
          field: 'customer_number',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
        },
        {
          label: 'Customer Name',
          field: 'customer_name',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
        },
        {
          label: 'Date Billed From',
          field: 'bill_from_date',
          filterable: true,
          fpFieldType:"custom_date",
          hidden:false,
        },
        {
          label: 'Date Billed To',
          field: 'bill_to_date',
          filterable: true,
          fpFieldType:"custom_date",
          hidden:false,
        },
    ],
    batchProcess:0,
    batchNum:"",



  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'metrics_billed_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  created: function() {
      this.serverParams.stopRequest = true;
  },
  methods:{
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/metrics-billed-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,


        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {

            console.log('success');
            if (self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              self.loadList();


            } else {

              if (data.content.row != undefined) {

                console.log("data.content.log");
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;

            }

          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'metrics-billed-report');
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/MetricsBilledReport.vue